import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import randomstring from 'uuid/v4';

import { AddIcon, TrashIcon } from '../../../../images/icons/WrapSvg';

class Machine extends React.Component {
    state = {
        maquinaria: this.props.info ? this.props.info : [],
        types: this.props.types ? this.props.types : [],
    };

    static getDerivedStateFromProps(props, state) {
        if (props.info && props.id !== state.idLocal) {
            const { info, types } = props;

            state.id = props.id;
            state.maquinaria = info ? info : false;
            state.types = types ? types : '';
            return state;
        }
        return null;
    }

    handleChange = (index, field, value) => {
        const { maquinaria } = this.state;
        maquinaria[index][field] = value;
        this.props.onChange('maquinaria', maquinaria);
        this.setState({ maquinaria: maquinaria });
    };

    handleClick = (event) => {
        const { maquinaria } = this.state;
        maquinaria.push({
            idTipomaquina: '',
            nombre: '',
        });
        this.props.onChange('maquinaria', maquinaria);
        this.setState({ maquinaria: maquinaria });
    };

    handleDelete = (index) => {
        const { maquinaria } = this.state;
        maquinaria.splice(index, 1);
        this.props.onChange('maquinaria', maquinaria);
        this.setState({ maquinaria });
    };

    render() {
        const { intl } = this.props;
        const { maquinaria, types } = this.state;
        console.log("Types", types);
        return (
            <Card className={'product_card margin_top_12'}>
                <CardContent>
                    <Grid container justify="center" className={'flex_grow_1'}>
                        <Grid item xs={12} className="">
                            <div className="barlow_regular_small c_dark_grey_blue upper margin_top_12 margin_bottom_5 text_align_left">
                                <span>{intl.formatMessage({ id: 'local_machine_title' })}</span>
                            </div>
                        </Grid>
                        <Grid
                            item
                            xs={6}
                            className="margin_top_12 margin_bottom_5 shadow_down_only c_slate_grey upper barlow_regular_small"
                        >
                            <FormattedMessage id="local_machine_name" />
                        </Grid>
                        <Grid
                            item
                            xs={6}
                            className="margin_top_12 margin_bottom_5 shadow_down_only c_slate_grey upper barlow_regular_small"
                        >
                            <FormattedMessage id="local_machine_alias" />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            className="margin_top_12 margin_bottom_5 shadow_down_only c_slate_grey upper barlow_regular_small"
                        >
                            {(maquinaria && maquinaria.length > 0) &&
                                maquinaria.map((m, index) => (
                                    <div
                                        key={`maquinaria-${index}`}
                                        className="flex_full_row align_center"
                                    >
                                        <FormControl
                                            fullWidth
                                            className="padding_top_12 padding_right_6"
                                        >
                                            <Select
                                                value={m.idTipomaquina}
                                                onChange={(event) =>
                                                    this.handleChange(
                                                        index,
                                                        'idTipomaquina',
                                                        event.target.value,
                                                    )
                                                }
                                                native
                                            >
                                                <option key={randomstring()} value={undefined} />
                                                {(types && types.length > 0) &&
                                                    types.map((t) => {
                                                        return (
                                                            <option
                                                                key={randomstring()}
                                                                value={t.id}
                                                            >
                                                                {t.nombre}
                                                            </option>
                                                        );
                                                    })}
                                            </Select>
                                        </FormControl>
                                        <TextField
                                            fullWidth
                                            required
                                            error={!m.nombre}
                                            helperText={
                                                !m.nombre
                                                    ? intl.formatMessage({ id: 'required' })
                                                    : ''
                                            }
                                            className={'flex_full_row'}
                                            value={m.nombre}
                                            onChange={(event) =>
                                                this.handleChange(
                                                    index,
                                                    'nombre',
                                                    event.target.value,
                                                )
                                            }
                                            margin="normal"
                                        />
                                        <TrashIcon
                                            className="margin_left_18 c_lipstick hand"
                                            onClick={() => this.handleDelete(index)}
                                        />
                                    </div>
                                ))}
                        </Grid>
                        <Grid item xs={12} className="">
                            <div className="flex_full_row margin_bottom_12">
                                <div
                                    onClick={this.handleClick}
                                    className="flex_full_row margin_bottom_5 margin_top_12 padding_borders elements_center align_center barlow_medium_place_holder c_bluish uppercase dottedBox hand"
                                >
                                    <span>{intl.formatMessage({ id: 'local_add_machine' })}</span>
                                    <AddIcon color="primary" className="icon" />
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        );
    }
}

Machine.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Machine);



// WEBPACK FOOTER //
// ./src/components/complex/inventory/local/Machine.js